export default __webpack_public_path__ + "static/media/banner2.d6b2ad71.jpg";